// @flow

export type PricingTierDto = {
  StartingUnit: number,
  EndingUnit: number | null,
  Price: number,
};

export type CurrencyEnumType = 0 | 1 | 2 | 3 | 4;

export const CurrencyEnum = {
  AUD: 0,
  USD: 1,
  GBP: 2,
  EUR: 3,
  ZAR: 4,
};

export type PricingModelType = 0 | 1 | 2 | 3 | 4;

export const PricingModelEnum = {
  FlatFee: 0,
  PerUnit: 1,
  Tiered: 2,
  Volume: 3,
  Stairstep: 4,
};

export const PricingModels = {
  FlatFee: 'FlatFee',
  PerUnit: 'PerUnit',
  Tiered: 'Tiered',
  Volume: 'Volume',
  Stairstep: 'Stairstep',
};

export type PlanPriceDto = {
  Id: string,
  Code: string,
  Name: string,
  Currency: CurrencyEnumType,
  FrequencyInMonths: number,
  PricingModel: PricingModelType,
  Price: number | null,
  OldPrice: number | null,
  Tiers: PricingTierDto[] | null,
  OldTiers: PricingTierDto[] | null,
};

export type Price = {
  lookupCode: string,
  productCode: string,
  price: string,
};

export type PriceGroup = 'OldPrices' | 'NewPrices';

export type PriceGroups = {
  OldPrices: Price[],
  NewPrices: Price[],
};
